export default __webpack_public_path__ + "static/media/cash_management.011fec9c.svg";